// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleRestrictedContentResponsiveContainer_wrapper__601OM","content":"ArticleRestrictedContentResponsiveContainer_content__aZeSo"};